import { render, staticRenderFns } from "./Templates/BusinessProfileUsers.html?vue&type=template&id=10ba1c6e&external"
import script from "./BusinessProfileUsers.vue?vue&type=script&lang=js"
export * from "./BusinessProfileUsers.vue?vue&type=script&lang=js"
import style0 from "./BusinessProfileUsers.vue?vue&type=style&index=0&id=10ba1c6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports